import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { tokens } from '@everfi/design-system';
import { CardHeader } from '../../../core/components/Card/card-header.js';
import { CardTitle } from '../card-title/component.js';
import { CardBody } from '../../../core/components/Card/card-body.js';
import { AttentionGrabber } from '../../attention-grabber/component.js';
import { GenericLabel } from '../../generic-label/component.js';
import { formatClassName as _formatClassName } from '../../../utils/formatClassName.js';
import { Layout } from '../../../core/components/Layout/component.js';
import { Label } from '../../../core/components/Label/component.js';
import { dataAttribsForEl } from '../../../utils/dataAttribsForEl.js';
import { Typography } from '../../../core/components/Typography/component.js';

var CardTextBox = function CardTextBox(props) {
  var alertMiniCard = props.alertMiniCard,
      _props$allowSecondary = props.allowSecondaryDetailLineBreaks,
      allowSecondaryDetailLineBreaks = _props$allowSecondary === void 0 ? false : _props$allowSecondary,
      attentionGrabber = props.attentionGrabber,
      _props$chakra = props.chakra,
      chakra = _props$chakra === void 0 ? 'on' : _props$chakra,
      className = props.className,
      _props$corner = props.corner,
      corner = _props$corner === void 0 ? 'none' : _props$corner,
      description = props.description,
      descriptionClass = props.descriptionClass,
      _props$descriptionDat = props.descriptionDataAttributes,
      _props$descriptionDat2 = _props$descriptionDat === void 0 ? {} : _props$descriptionDat,
      _props$descriptionDat3 = _props$descriptionDat2.context,
      context = _props$descriptionDat3 === void 0 ? {} : _props$descriptionDat3,
      optionalAttributes = _props$descriptionDat2.optionalAttributes,
      dismissable = props.dismissable,
      hasLabel = props.hasLabel,
      hasMedia = props.hasMedia,
      _props$hasRichTextCon = props.hasRichTextContent,
      hasRichTextContent = _props$hasRichTextCon === void 0 ? false : _props$hasRichTextCon,
      secondaryDetail = props.secondaryDetail,
      title = props.title,
      titleDataAttributes = props.titleDataAttributes,
      titleIcon = props.titleIcon,
      titleIconSize = props.titleIconSize,
      titleSize = props.titleSize,
      type = props.type;

  var textBoxClasses = _formatClassName([className, 'card-text', "card-text-".concat(type), {
    'has-label': hasLabel
  }, {
    'has-media': hasMedia
  }, {
    'alert-mini-card': alertMiniCard
  }, "card-corner-".concat(corner)]);

  var getLabelText = function getLabelText(detail) {
    if (detail.value) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
        as: "span",
        fontWeight: tokens.FontWeightBold
      }, detail.label, ":", ' '), "\xA0", detail.value);
    }

    return detail.label || detail;
  };

  var getCoreLabelProps = function getCoreLabelProps(detail) {
    if (detail.icon) {
      return {
        type: detail.iconPosition === 'right' ? 'iconRight' : 'iconLeft',
        options: {
          text: getLabelText(detail),
          icon: {
            iconName: detail.icon // TODO other icon properties

          }
        }
      };
    }

    return {
      type: 'textOnlyLabel',
      options: {
        text: getLabelText(detail)
      }
    };
  };

  var renderSecondaryDetail = function renderSecondaryDetail() {
    if (!secondaryDetail) return null;

    if (Array.isArray(secondaryDetail)) {
      return /*#__PURE__*/React.createElement("div", {
        className: "card-secondary-detail"
      }, secondaryDetail.map(function (detail, index) {
        return chakra === 'on' ? /*#__PURE__*/React.createElement(Layout, {
          marginRight: tokens.SpacingBaseXs,
          display: "inline-block"
        }, /*#__PURE__*/React.createElement(Label, {
          key: "detail-".concat(index),
          label: getCoreLabelProps(detail)
        })) : /*#__PURE__*/React.createElement(GenericLabel, _extends({
          key: index
        }, detail));
      }));
    } else {
      return chakra === 'on' ? /*#__PURE__*/React.createElement(Label, {
        label: {
          type: 'textOnlyLabel',
          options: {
            text: getLabelText(secondaryDetail)
          }
        }
      }) : /*#__PURE__*/React.createElement(GenericLabel, {
        allowLineBreaks: allowSecondaryDetailLineBreaks,
        className: "card-secondary-detail",
        label: secondaryDetail
      });
    }
  };

  var getDescriptionClasses = function getDescriptionClasses() {
    return _formatClassName(['card-description', descriptionClass]);
  };

  var renderDescription = function renderDescription() {
    if (!description) return null;
    var descriptionClasses = getDescriptionClasses();
    var descriptionDataAttributes = dataAttribsForEl(context, optionalAttributes);

    if (hasRichTextContent) {
      return /*#__PURE__*/React.createElement("div", _extends({
        // @ts-ignore
        dangerouslySetInnerHTML: {
          __html: description
        },
        className: descriptionClasses
      }, descriptionDataAttributes));
    }

    return chakra === 'on' ? /*#__PURE__*/React.createElement(Typography, null, description) : /*#__PURE__*/React.createElement("div", _extends({
      className: descriptionClasses
    }, descriptionDataAttributes), description);
  };

  var renderAttentionGrabber = function renderAttentionGrabber() {
    if (!attentionGrabber) return null;
    return (
      /*#__PURE__*/
      // TODO: make this a Core Tag for Chakra
      React.createElement(AttentionGrabber, _extends({}, attentionGrabber, {
        className: _formatClassName([attentionGrabber.className, {
          'm-b-10': !!description
        }])
      }))
    );
  };

  return chakra === 'on' ? /*#__PURE__*/React.createElement(Layout, {
    height: "100%",
    width: "100%"
  }, /*#__PURE__*/React.createElement(CardHeader, null, /*#__PURE__*/React.createElement(CardTitle, {
    chakra: chakra,
    size: titleSize,
    icon: titleIcon,
    iconSize: titleIconSize,
    isDismissable: dismissable,
    titleDataAttributes: titleDataAttributes,
    type: type,
    secondaryDetail: chakra === 'on' ? renderSecondaryDetail() : null,
    attentionGrabber: chakra === 'on' ? renderAttentionGrabber() : null
  }, title)), /*#__PURE__*/React.createElement(CardBody, null, renderDescription())) : /*#__PURE__*/React.createElement("div", {
    className: textBoxClasses
  }, title && /*#__PURE__*/React.createElement(CardTitle, {
    chakra: chakra,
    size: titleSize,
    icon: titleIcon,
    iconSize: titleIconSize,
    titleDataAttributes: titleDataAttributes,
    type: type
  }, title), renderSecondaryDetail(), renderAttentionGrabber(), renderDescription());
};

CardTextBox.displayName = 'CardTextBox';
export { CardTextBox };